import { Link, SxProps } from "@mui/material";
import { Parameter } from "../../../common/types/parameters";
import { Column } from "../types";
import ParameterSection from "../parameter-section";
import {
  supplementalDistrictHeatingCostSummarySections,
  supplementalDistrictHeatingInputSections,
} from "./supplemental-district-heating-sections";

/** Same prefix as supplemental cost stack in graph (ExhaustAirSupplementalDistrictHeating*). */
const HEAT_TECH_PREFIX = "ExhaustAir";

export default function ExhaustAirHeatPump(params: {
  description?: string;
  printTitle: string;
  parameters: Parameter[];
  includeVat: boolean;
  toPrint: boolean;
  onValidParameterChange?: (id: string, value: string) => void;
  onSectionChange?: (targetTab: string) => void;
  sx?: SxProps;
}) {
  return (
    <ParameterSection
      printTitle={params.printTitle}
      description={params.description}
      parameters={params.parameters}
      columns={columns(params.onSectionChange)}
      toPrint={params.toPrint}
      includeVat={params.includeVat}
      onValidParameterChange={params.onValidParameterChange}
      sx={params.sx}
    />
  );
}

const columns = (onSectionChange: ((targetTab: string) => void) | undefined) =>
  [
    {
      sections: [
        {
          title: "Årliga kostnader",
          parameters: [
            "ExhaustAirCapitalCost",
            "ExhaustAirHeatPumpMaintenanceCost",
            "ExhaustAirSupplementalDistrictHeatingTotalCostsSum",
            "ExhaustAirEnergyCost",
            "ExhaustAirIncreasedGridCost",
          ],
        },
        {
          title: "",
          parameters: ["ExhaustAirTotalSpecificCost"],
        },
        ...supplementalDistrictHeatingCostSummarySections(HEAT_TECH_PREFIX),
        {
          title: "Beräknade värden för nytt elabonnemang",
          parameters: [
            "ExhaustAirAndBuildingElectricityLoad",
            "ExhaustAirFuseDemand",
          ],
        },
      ],
      readOnly: true,
    },
    {
      description: (
        <>
          Prislistor kan justeras på den{" "}
          <Link
            href="#"
            onClick={() => {
              if (onSectionChange !== undefined) {
                onSectionChange("Common");
              }
            }}
          >
            Övergripande
          </Link>{" "}
          fliken.
        </>
      ),
      sections: [
        {
          title: "Detaljerade indata",
          parameters: [
            "ExhaustAirHeatingDesignLoad",
            "ExhaustAirHeatPumpLoadCoverage",
            "ExhaustAirHeatPumpEnergyCoverage",
            "ExhaustAirHeatPumpDeliveredHeatingLoad",
            "ExhaustAirRemainingHeatingLoad",
            "ExhaustAirHeatPumpSCOPRadiator",
            "ExhaustAirHeatPumpSCOPFloor",
          ],
        },
        {
          title: "Investeringskostnad",
          parameters: [
            "ExhaustAirHeatPumpCost",
            "ExhaustAirHeatPumpLifeSpan",
            "ExhaustAirMiscellaneousCost",
            "ExhaustAirMiscellaneousLifeSpan",
          ],
        },
        {
          title: "Drift- och underhållskostnader",
          parameters: ["ExhaustAirHeatPumpMaintenanceCost"],
        },
        ...supplementalDistrictHeatingInputSections(HEAT_TECH_PREFIX),
      ],
    },
  ] as Column[];
